/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';
import { property } from 'lit/decorators.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import styles from './leadspace-with-search.scss';
import StableSelectorMixin from '../../globals/mixins/stable-selector';
import C4DContentBlockParagraph from '../content-block/content-block-paragraph';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';

const { stablePrefix: c4dPrefix } = settings;

/**
 * Copy in the content section of Leadspace with search
 *
 * @element c4d-leadspace-with-search-copy
 */
@customElement(`${c4dPrefix}-leadspace-with-search-copy`)
class C4DLeadspaceWithSearchCopy extends StableSelectorMixin(
  C4DContentBlockParagraph
) {
  /**
   * The shadow slot the content should be in.
   */
  @property({ reflect: true })
  slot = 'copy';

  static get stableSelector() {
    return `${c4dPrefix}--leadspace-with-search-content-copy`;
  }

  // `styles` here is a `CSSResult` generated by custom WebPack loader
  static get styles() {
    return css`
      ${super.styles}${styles}
    `;
  }
}

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DLeadspaceWithSearchCopy;
